var app_strata_table = $('#app-strata-table');

if (app_strata_table.length) {
    initializeStrataTable();
      function initializeStrataTable() {
            var advertiser = $('#app-strata-table').attr('data-advertiser');
            console.log(advertiser);
            $('#app-strata-table').DataTable({
                ajax: {
                    url: '/advertisers/imported_from_strata/list',
                    dataSrc: 'data',
                },
                order: [ 0, "desc" ],
                columns: [
                    {data: 'id'},//0
                    {data: 'id'},//1
                    {data: 'file_name'},//2
                    {data: 'advertiser'},//3
                    {data: 'campaign'},//4
                    {data: 'media_type'},//5
                    {data: 'date'},//6
                    {data: 'id'},//7
                ],
                destroy: true,
                pageLength: user_entries,
                "columnDefs": [
                    {
                        "targets": 0,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            var html = ' <div class="checkbox checkbox-danger camp_strata_check">' +
                                ' <input class="checkbox input_checkbook_invo" class="form-control" type="checkbox"  id="' + rowData.id + '" name="selected_strata_camp[]" ' +
                                'value="' + rowData.id + '" >' +
                                '<label for="' + rowData.id + '"> </label></div>';
                            $(td).html(html);

                        }
                    },
                    {
                        "targets": 1,
                        "visible": false,
                    },
                    {
                        "targets": 3,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            $(td).html('<a href="' + rowData.adv_url + '">' + cellData + '</a>');
                        }
                    },
                    {
                        "targets": 4,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            $(td).html('<a href="' + rowData.camp_url + '">' + cellData + '</a>');
                        }
                    },
                    {
                        "targets": 6,
                        "orderable": false,
                    },
                    {
                        "targets": 7,
                        "orderable": false,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            $(td).html('<div class="btn-group " role="group"><a href="javascript:void(0)" onclick="deleteImportedStrata(' + cellData + ')" role="button" class="btn btn-danger btn-sm"><i class="fa fa-trash-o"></i> Delete</a></div>');
                        }
                    },
                ]
            });
        }
    $('#app-strata-table').on( 'length.dt', function ( e, settings, len ) {
        user_entries= len;
    });

    $('#select_all_camp_strata').on('click', function (e) {
        $('#app-strata-table input:checkbox').prop('checked', true);
    });
    $('#deselect_all_camp_strata').on('click', function (e) {
        $('#app-strata-table input:checkbox').prop('checked', false);
    });

    $('#delete_multiple_camp_strata').on('click', function () {
        var selectedItems = [];
        $('.camp_strata_check input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push(parseInt($(this).val()));
        });
        if (selectedItems.length > 0) {
            swal({
                    title: "Warning",
                    text: 'Are you sure to delete the External Worksheet/Buy File(s)?',
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "Yes",
                    cancelButtonText: "No",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        show_loader();
                        var url_one = '/adv/strata/imported/multiple_delete';
                        var params = {
                            campaigns: selectedItems,
                        };
                        $.ajax({
                            type: 'POST',
                            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                            data: JSON.stringify(params),
                            url: url_one,
                            dataType: "json",
                            contentType: "application/json",
                            success: function (response) {
                                global_notification('success', 'External Worksheet/Buy File(s) deleted...');
                                initializeStrataTable();
                                hide_loader();
                            },
                            error: function (xhr) {
                                hide_loader();
                                ajax_error();
                                debug(xhr.responseText);
                            }
                        });
                    }
                });

        } else {
            swal({
                    title: "Warning",
                    text: 'Select at least one External Worksheet/Buy File.',
                    type: "warning",
                   // showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "Ok",
                  //  cancelButtonText: "No",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                });
        }
    });

    function deleteImportedStrata(id) {
        swal({
                title: "Warning",
                text: "Are you sure to delete this External Worksheet/Buy File?",
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn-danger",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    show_loader();
                    $.ajax({
                        url: "/strata/delete?id="+id,
                        success: function (response) {
                            global_notification('success', 'External Worksheet/Buy File deleted.');
                            initializeStrataTable();
                            hide_loader();
                        },
                        error: function (xhr) {
                            if (xhr.status === 422) {
                                global_notification('warning', xhr.responseJSON.message);
                            } else {
                                ajax_error();
                                debug(xhr.responseText);
                            }
                            hide_loader();
                        }
                    });
                }
            });

    }
}